import { Box, Container, Text, useMatches } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { UserFeedback } from "@/components/widgets/UserFeedback";
import { global_settings } from "@/config";
import { Attachment } from "@/types/attachment";

const BetaBanner = () => {
  const { t } = useTranslation();

  const [feedbackOpened, { open: openChat, close: closeChat }] = useDisclosure(false);
  const [feedbackImage] = useState<Attachment | null>(null);

  const isMobile = useMatches({
    base: true,
    md: false,
  });

  if (!global_settings.enableBetaUIElements) return null;

  return (
    <>
      <Box
        w="100%"
        style={{
          zIndex: 50,
          userSelect: "none",
          backgroundColor: "#f28d5e",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <Box
          component="style"
          dangerouslySetInnerHTML={{
            __html: `
              @keyframes beta-marquee {
                from {
                  transform: translateX(0);
                }

                to {
                  transform: translateX(-50%);
                }
              }
            `,
          }}
        />

        <Container
          size="lg"
          h={40}
          px="md"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <Box
            style={{
              overflow: "hidden",
              flex: 1,
            }}
          >
            {!isMobile ? (
              /* Desktop version */
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 4,
                  whiteSpace: "nowrap",
                }}
              >
                <Text size="sm" fw={700} c="black" lh={1}>
                  {t("feedback.beta.title")}
                </Text>

                <Box
                  component="span"
                  onClick={openChat}
                  style={{
                    textDecoration: "underline",
                    textDecorationThickness: "0.1em",
                    textUnderlineOffset: "0.125em",
                    cursor: "pointer",
                    display: "inline-block",
                    fontWeight: 700,
                    fontSize: "var(--mantine-font-size-sm)",
                    color: "black",
                  }}
                >
                  {t("feedback.beta.contactUs")}
                </Box>
              </Box>
            ) : (
              /* Mobile version */
              <Box
                style={{
                  overflow: "hidden",
                  width: "100%",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    width: "max-content",
                    animation: "beta-marquee 18s linear infinite",
                    willChange: "transform",
                  }}
                >
                  {[0, 1].map((index) => (
                    <Box
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        whiteSpace: "nowrap",
                        flexShrink: 0,
                        paddingRight: 48,
                      }}
                    >
                      <Text size="sm" fw={700} c="black">
                        {t("feedback.beta.title")}{" "}
                        <Box
                          component="span"
                          onClick={openChat}
                          style={{
                            textDecoration: "underline",
                            textDecorationThickness: "0.1em",
                            textUnderlineOffset: "0.125em",
                            cursor: "pointer",
                          }}
                        >
                          {t("feedback.beta.contactUs")}
                        </Box>
                      </Text>
                    </Box>
                  ))}
                </Box>
              </Box>
            )}
          </Box>
        </Container>
      </Box>

      <UserFeedback
        title={t("feedback.beta.contactUs")}
        description={t("feedback.beta.earlyAccessShortDescription")}
        opened={feedbackOpened}
        image={feedbackImage}
        onOpenedChange={closeChat}
      />
    </>
  );
};

export default BetaBanner;
